import type { AcceleronTaxItems, FeeOverride, GenericObject } from '@makemydeal/dr-platform-types';

export enum DasOverridesFlags {
    feesCapitalized,
    taxesCapitalized,
    targetCashAmountPaid,
    firstPaymentCapitalized
}

export enum DasOverridesCompare {
    downPayment,
    feesCapitalized,
    taxesCapitalized,
    targetCashAmountPaid,
    firstPaymentCapitalized,
    equityAllocationMethod
}

type DasOverridesFlagsKeys = keyof typeof DasOverridesFlags;

export type DasOverridesFlagsTypes = Partial<{
    [K in DasOverridesFlagsKeys]: boolean;
}>;

export type DasOverridesRequest = {
    state: GenericObject;
    targetName: string;
    targetValue: boolean;
};

export type DasOverrides = DasOverridesFlagsTypes &
    Partial<{
        downPayment: number;
        feesOverride: FeeOverride[];
        taxItems: AcceleronTaxItems;
        equityAllocationMethod: string;
        capCostReduction: number;
        secDeposit: number;
        netTrade: number;
        totalRebates: number;
        cashDueFromCustomer: number;
        targetCashAmountPaid: boolean;
    }>;

export type DasPayload = Partial<{
    taxItems: AcceleronTaxItems;
    downPayment: number;
    feesOverride: FeeOverride[];
    taxOverrideUpfront: boolean;
    isTargetOutOfPocket: boolean;
    capitalizeFirstPayment: boolean;
    equityAllocationMethod: string;
}>;

export type DasPayment = Partial<{
    firstPayment: number;
    upfrontTaxTotal: number;
    upfrontFeesTotal: number;
    capCostReduction: number;
    secDeposit: number;
    netTrade: number;
    upfrontAddonsTotal: number;
    totalRebates: number;
    cashDueFromCustomer: number;
    netCashDown: number;
    downPayment: number;
    diaDueAtSigning: number;
    dueAtSigning: number;
    targetCashAmountPaid: boolean;
    priorLoanBalance: number;
    totalAmountDue: number;
    firstPaymentCapitalized: boolean;
}>;

export type InfoMessage = {
    heading: string;
    content: string;
};

export type DasEditAction = {
    type: string;
    payload?: GenericObject;
};

export type DasState = {
    errors?: GenericObject<string>[];
    payment?: DasPayment;
    messages?: InfoMessage[];
    overrides: DasOverrides;
    isApplied?: boolean;
    isCalculating?: boolean;
    isApplying?: boolean;
    isSlideOutOpen?: boolean;
    equityAllocationMethod?: string;
};

export type DasToggleOpenPayload = { payment: DasPayment; overrides: DasOverrides };
